export default "__VITE_ASSET__Cp8xCB35__"